import { base64 } from '../utils/index'

const state = {
  fundsAuth: localStorage.getItem('A') ? JSON.parse(base64.decode(localStorage.getItem('A'))) : '',
  userRole: localStorage.getItem('R') ? JSON.parse(base64.decode(localStorage.getItem('R'))) : '',
  userInfo: localStorage.getItem('I') ? JSON.parse(base64.decode(localStorage.getItem('I'))) : '',
  homeInfo: localStorage.getItem('H') ? JSON.parse(base64.decode(localStorage.getItem('H'))) : '',
  // 面包屑
  bread: localStorage.getItem('bread') ? JSON.parse(localStorage.getItem('bread')) : {
    oB: '首页',
    topPath: 1,
    children: [{
      name: '首页',
      path: '/home'
    }]
  },
  // 左侧list
  leftList: [],
  listType: localStorage.getItem('ListType') ? localStorage.getItem('ListType') : 1,
  accountType: localStorage.getItem('at') ? localStorage.getItem('at') : '',
  leftActive: localStorage.getItem('leftActive') ? localStorage.getItem('leftActive') : 1,
  // 名下用户展开数组
  expandedKey: [],
  showBindBox: 0,
  // 存款是否新版本 默认新版本 直接跳转收银台
  //isNewDeposit: true
}
export default state


// WEBPACK FOOTER //
// ./src/store/state.js